import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  Box,
  InputLabel,
  MenuItem,
  Select,
  FormHelperText,
  TextField,
} from "@mui/material";
import { Controller } from "react-hook-form";

const FormSelect = ({
  control,
  defaultValue,
  items,
  label,
  controllerName,
  type,
  size,
  placeholder,
  disabled,
}) => {
  return (
    <FormControl
      sx={{
        display: "flex",
        flexDirection: "column",
        mt: "15px",
      }}
    >
      <Controller
        name={controllerName}
        control={control}
        defaultValue={defaultValue}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <>
            <TextField
              select
              label={label}
              value={value ? value : ""}
              onChange={onChange}
              error={!!error}
              helperText={error ? error.message : null}
              type={type}
              size={size}
              placeholder={placeholder}
              disabled={disabled}
              // disabled={disabled}
              // InputLabelProps={InputLabelProps}
              // margin={margin}
              fullWidth
            >
              {items.map((option) =>
                typeof option === "string" ? (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ) : (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                )
              )}
            </TextField>
          </>
        )}
      />
    </FormControl>
  );
};

FormSelect.propTypes = {
  label: PropTypes.string,
  controllerName: PropTypes.string,
  items: PropTypes.array,
  type: PropTypes.string,
  size: PropTypes.string,
  placeholder: PropTypes.string,
};

FormSelect.defaultProps = {
  label: "",
  controllerName: "",
  items: [],
  type: "text",
  size: "medium",
  placeholder: "",
};

export default FormSelect;
